module.exports = __webpack_public_path__ + "img/744.4620d9f6.jpg";